export default {
  '1': '正常',
  '2': '保养后正常',
  '3': '不正常',
}